import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import MenuIcon from '@mui/icons-material/Menu';

import UserProfileModal from '../modals/UserProfile';

import { withFirebase } from '../../firebase';

import { toggleSidebar } from '../../actions/sidebarActions';

// import { userRoles } from '../../constants';

import './dashboard.scss';
import Avatar from '@mui/material/Avatar';

const DashboardHeaderMobile = (props) => {
  const { user, toggleSidebar } = props;

  const [isOpen, toggleModal] = useState(false);

  // const displayUserRole = (role) => userRoles[role] && userRoles[role].label;
  // const imageUrl = 'dashboard-header.png';

  return (
    <Box className="dashboard-header-mobile" sx={{ backgroundColor: (theme) => theme.palette.primary.main }}>
      <div className="menu-icon-container">
        <IconButton edge="start" color="secondary" aria-label="menu" onClick={toggleSidebar}>
          <MenuIcon sx={{ color: '#ffffff' }} />
        </IconButton>
      </div>

      <div className="dashboard-header-mobile__avatar" onClick={() => toggleModal(true)}>
        <Avatar
          src={user?.photoUrl}
          alt={user.firstName}
          sx={{ width: 44, height: 44 }}
        />
      </div>
      {/*<div className="dashboard-header-info">*/}
      {/*  <div className="dashboard-user-name">*/}
      {/*    <div>*/}
      {/*      {user.firstName &&*/}
      {/*        user.lastName &&*/}
      {/*        `${user.role === userRoles.SURGEON.name ? 'Dr. ' : ''}${user.firstName} ${*/}
      {/*          user.lastName*/}
      {/*        }`}*/}
      {/*    </div>*/}
      {/*    <div className="font-size-sm">{displayUserRole(user.role)}</div>*/}
      {/*  </div>*/}
      {/*  <div className="edit-link" onClick={() => toggleModal(true)}>*/}
      {/*    Edit*/}
      {/*  </div>*/}
      {/*</div>*/}
      <UserProfileModal
        open={isOpen}
        onClose={() => toggleModal(false)}
        onSubmit={() => console.log('submit')}
        userFirstName={user ? user.firstName : ''}
        userLastName={user ? user.lastName : ''}
        userAddress={user ? user.address : ''}
        userPhone={user ? user.phone : ''}
        adminPassword={!!user.adminPassword}
        currentUser={user}
      />
    </Box>
  );
};

DashboardHeaderMobile.propTypes = {
  user: PropTypes.object,
  toggleSidebar: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    user: state.user.currentUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleSidebar: () => dispatch(toggleSidebar()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withFirebase(DashboardHeaderMobile));
